import { render, staticRenderFns } from "./lonchera-penalizacion.vue?vue&type=template&id=59fb25d5&"
import script from "./lonchera-penalizacion.vue?vue&type=script&lang=js&"
export * from "./lonchera-penalizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports